/**
 * TOPFV改修ABテスト用のGAイベント発火ユーティリティ
 * Issue #373の仕様に基づくイベント発火機能
 */
import GTM from '@/utils/tracking/gtm'
import { TOP_FV_V4_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'
import useABTestV2 from '@/utils/abtest/useABTestV2'

const EVENT_CATEGORY = 'TOPFV改修'

/**
 * ABテストのパターンラベルを取得
 * @returns {string} 'A' または 'B' または 'OFF'（テスト無効時）
 */
function getPatternLabel() {
  const { isAPattern, isBPattern } = useABTestV2(TOP_FV_V4_AB_TEST_CONFIG)

  if (isAPattern) return 'A'
  if (isBPattern) return 'B'
  return 'OFF' // テストが無効の場合
}

/**
 * TOPページ閲覧時のイベント発火
 */
export function sendTopPageViewEvent() {
  const patternLabel = getPatternLabel()

  // A/Bテストが無効の場合は送信しない
  if (patternLabel === 'OFF') {
    return
  }

  GTM.sendEventToGa({
    category: EVENT_CATEGORY,
    action: 'view',
    label: patternLabel
  })
}

/**
 * 詳細ページ遷移時のイベント発火
 */
export function sendDetailTransitionEvent() {
  const patternLabel = getPatternLabel()

  // A/Bテストが無効の場合は送信しない
  if (patternLabel === 'OFF') {
    return
  }

  GTM.sendEventToGa({
    category: EVENT_CATEGORY,
    action: 'click',
    label: `${patternLabel}、詳細遷移`
  })
}

/**
 * 一覧ページ遷移時のイベント発火
 * @param {string} source 遷移元（例: 'ヘッダー', '街コンを探す', 'すぐ行ける街コン', '他の日程を見る', 各バナー等）
 */
export function sendListTransitionEvent(source = '') {
  const patternLabel = getPatternLabel()

  // A/Bテストが無効の場合は送信しない
  if (patternLabel === 'OFF') {
    return
  }

  GTM.sendEventToGa({
    category: EVENT_CATEGORY,
    action: 'click',
    label: `${patternLabel}、一覧遷移、${source}`
  })
}

/**
 * ヘッダー検索アイコンタップ時のイベント発火
 */
export function sendHeaderSearchTapEvent() {
  const patternLabel = getPatternLabel()

  // A/Bテストが無効の場合は送信しない
  if (patternLabel === 'OFF') {
    return
  }

  GTM.sendEventToGa({
    category: EVENT_CATEGORY,
    action: 'click',
    label: `${patternLabel}、タップのみ、ヘッダー`
  })
}

/**
 * 「他の日程も見る」タップ時のイベント発火
 */
export function sendOtherDatesTapEvent() {
  const patternLabel = getPatternLabel()

  // A/Bテストが無効の場合は送信しない
  if (patternLabel === 'OFF') {
    return
  }

  GTM.sendEventToGa({
    category: EVENT_CATEGORY,
    action: 'click',
    label: `${patternLabel}、タップのみ、他の日程を見る`
  })
}

/**
 * 「街コンを探す」タップ時のイベント発火
 * @param {string} searchType 検索タイプ（'日付' または '都道府県'）
 */
export function sendSearchEventTapEvent(searchType = '') {
  const patternLabel = getPatternLabel()

  // A/Bテストが無効の場合は送信しない
  if (patternLabel === 'OFF') {
    return
  }

  GTM.sendEventToGa({
    category: EVENT_CATEGORY,
    action: 'click',
    label: `${patternLabel}、タップのみ、${searchType}`
  })
}
